import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { persistStore } from 'redux-persist';

import configPersist from './persistConfig';
import { createBrowserHistory } from 'history';
import reducers from './reducers';

//Middlewares
import logger from 'redux-logger';
import thunk from "redux-thunk";

export const history = createBrowserHistory();

const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
export const persistedReducers = configPersist('root', { whitelist: ['requirements'] }, reducers(history));

export const store = applyMiddleware(
  logger,
  thunk,
  routerMiddleware(history)
)(createStore)(persistedReducers, devTools);

export const persistor = persistStore(store);
